import type { RouteLocationRaw } from 'vue-router';

import { t } from '@/i18n';
import type { AppActionDefinition } from '@/types/core';

class AppAction implements AppActionDefinition {
  allowed?: boolean;
  handler?: () => void;
  icon?: string;
  name: string;
  route?: RouteLocationRaw;
  children: AppAction[];

  #label?: string;

  constructor(model: AppActionDefinition, children?: AppAction[]) {
    if (!model.name) throw new Error('AppAction: Cannot create action without a unique name.');

    this.allowed = model.allowed;
    this.handler = model.handler;
    this.icon = model.icon;
    this.name = model.name;
    this.route = model.route;
    this.children = children ?? [];

    this.#label = model.label;
  }

  get label(): string {
    return this.#label ?? t(`routeNames.${this.name}`);
  }
}

export default AppAction;
